import { analytics } from '../firebase/firebaseService';
import { logEvent } from 'firebase/analytics';
import { BaseAnalyticsService } from './baseAnalyticsService';

export class FirebaseAnalyticsService extends BaseAnalyticsService {
  logEvent(eventName: string, eventParams?: Record<string, any>) {
    const defaultParams = {
      environment: process.env.NODE_ENV,
    };
    const finalParams = { ...defaultParams, ...eventParams };
    if (analytics.app) {
      logEvent(analytics, eventName, finalParams);
    } else {
      console.warn(
        'firebase logEvent called while not initialized',
        eventName,
        eventParams,
      );
    }
  }
}

export const firebaseAnalyticsService = new FirebaseAnalyticsService();
